module.exports = __webpack_public_path__ + "dui_img.8e848450.png";